module.exports = __webpack_public_path__ + "img/code.47e2f1c9.png";